import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const Img = styled('img')`
  width: 100%;
  height: ${(p) => p.theme.spacing(34)};
  border: '2px solid ${(p) => p.theme.palette.common.white}';
  border-radius: ${(p) => p.theme.spacing(1.5)};
`;

export const Avatar = styled('img')`
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
`;
